const DISMISSED_STORAGE_KEY = "nema_dismissed_call_sessions";
const ACTIVE_CALL_STORAGE_KEY = "nema_messenger_active_call";
const MAX_DISMISSED = 40;

export function sessionKey(id) {
  return id == null ? "" : String(id);
}

function readDismissedSet() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(DISMISSED_STORAGE_KEY) || "[]");
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map((id) => String(id)).filter(Boolean));
  } catch {
    return new Set();
  }
}

function writeDismissedSet(set) {
  const values = [...set].map(String).filter(Boolean).slice(-MAX_DISMISSED);
  sessionStorage.setItem(DISMISSED_STORAGE_KEY, JSON.stringify(values));
}

export function markDismissedCallSession(id) {
  const key = sessionKey(id);
  if (!key) return;
  const set = readDismissedSet();
  set.add(key);
  writeDismissedSet(set);
}

export function isDismissedCallSession(id) {
  return readDismissedSet().has(sessionKey(id));
}

export function filterActiveIncomingCalls(calls) {
  return (calls || []).filter((call) => {
    if (String(call?.status || "").toUpperCase() !== "RINGING") return false;
    return !isDismissedCallSession(call.id);
  });
}

export function clearPendingIncomingCall() {
  sessionStorage.removeItem("nema_pending_incoming_call");
}

export function stashActiveCallPayload(payload) {
  const rtc = payload?.rtcCredentials || payload?.rtc;
  if (!rtc?.token) return;
  sessionStorage.setItem(ACTIVE_CALL_STORAGE_KEY, JSON.stringify(payload));
}

export function consumeActiveCallPayload() {
  const raw = sessionStorage.getItem(ACTIVE_CALL_STORAGE_KEY);
  sessionStorage.removeItem(ACTIVE_CALL_STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    const rtc = parsed?.rtcCredentials || parsed?.rtc;
    return rtc?.token ? parsed : null;
  } catch {
    return null;
  }
}
